import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
// import ChartContact from "../../../Components/ChartContact.jsx";
import CampagnEmailService from "./../../../../services/MarketingService/CampagnEmailService"
import clientService from "./../../../../services/MarketingService/ClientService"
import moment from "moment";
import ChartContact from "../../Charts/ChartContact";
function StatCampagneE() {
  const [data, setData] = useState({});

  const [photos, setPhotos] = useState([]);
  const [images, setImages] = useState([]);

  const { id } = useParams();

  const [genreData, setGenreData] = useState(2);

  //data de chart contact
  const dataContact = {
    labels: ["Femme", "Homme"],
    datasets: [
      {
        data: [
          genreData && genreData["Femme"],
          genreData && genreData["Homme"],
        ],
        backgroundColor: ["#FF6384", "#36A2EB"],
        hoverBackgroundColor: ["#FF6384", "#36A2EB"],
      },
    ],
  };

  useEffect(() => {
    async function countgenres() {
      try {
        const response = await CampagnEmailService.countgenres(id); // assuming countGenre is a function that returns the genre count data
        setGenreData(response.data);
      } catch (error) {
        console.log(error);
      }
    }
    countgenres();
    console.log(data);
  }, []);

  const fetchData = async () => {
    try {
      const response = await CampagnEmailService.getCampagneEmailByID(id);
      setData(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchPhotos = async () => {
    try {
      const responsePhotosId =
        await CampagnEmailService.getCampagneEmailPhotosId(id);
      setPhotos(responsePhotosId.data);
      const fetchedPhotos = await Promise.all(
        responsePhotosId.data.map(async (photoId) => {
          const responsePhotos = await CampagnEmailService.showImage(photoId);
          return responsePhotos;
        })
      );
      setImages(fetchedPhotos);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
    fetchPhotos();
  }, [id]);

  return (
    <>
      {/* content-header */}
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0">Campagne Email </h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <a href="#">Marketing</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="/Campagne">Campagne</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="/Campagne/PageCampagneE">Email</a>
                  </li>
                  <li className="breadcrumb-item active">
                    {data && data.nom ? data.nom : ""}
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        {/* /.content-header */}
        {/* Main content */}
        <section className="content">
          <div className="row row-cols-2">
            {/* Contenu Email */}

            <div className="col">
              <div className="card mb-4">
                <div className="card-header">
                  <strong>Contenu Email </strong>
                  <span className="small ms-1">
                    | Les informations incluses dans la campagne d'e-mail
                  </span>
                </div>
                <div className="card-body">
                  <ul>
                    <li>
                      <strong>Nom de l'email : </strong>
                      {data && data.nom ? data.nom : ""}
                    </li>
                    <li>
                      <strong>Objectif de l'email : </strong>
                      {data && data.objectif ? data.objectif : ""}
                    </li>
                    <li>
                      <strong>Contenu de l'email : </strong>
                      {data && data.contenu ? data.contenu : ""}
                    </li>
                    <li>
                      <strong>Budget de l'email : </strong>
                      {data && data.budget ? data.budget : ""}
                    </li>
                    <li>
                      <strong>nombre de destinataire de l'email : </strong>
                      {data && data.clients ? data.clients.length : ""}
                    </li>
                    <li>
                      <strong>Date debut de lancement de l'email : </strong>
                      {data && data.debutDate
                        ? moment(data.debutDate).format("YYYY-MM-DD")
                        : ""}{" "}
                      |<strong> Heure : </strong>
                      {data && data.debutDate
                        ? moment(data.debutDate).format("HH:mm:ss")
                        : ""}
                    </li>
                    <li>
                      <strong>Date fin de lancement de l'email : </strong>
                      {data && data.finDate
                        ? moment(data.finDate).format("YYYY-MM-DD")
                        : ""}{" "}
                      |<strong> Heure : </strong>
                      {data && data.finDate
                        ? moment(data.finDate).format("HH:mm:ss")
                        : ""}
                    </li>
                    <li>
                      <strong>Statut de l'email : </strong>
                      {data && data.statut ? (
                        data.statut === "terminé" ? (
                          <span className="badge badge-danger">
                            {data.statut}
                          </span>
                        ) : data.statut === "encours" ? (
                          <span className="badge badge-primary">
                            {data.statut}
                          </span>
                        ) : (
                          <span className="badge badge-success">
                            {data.statut}
                          </span>
                        )
                      ) : (
                        ""
                      )}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* end of Contenu Email */}
            {/* Template */}
            {data.templatehtml && (
              <div className="col">
                <div className="card mb-4">
                  <div className="card-header">
                    <strong>Template</strong>
                    <span className="small ms-1">
                      | Le modèle qui contiendra l'e-mail
                    </span>
                  </div>
                  <div className="card-body">
                    <h5>
                      <strong>Objet de l'email : </strong>
                      {data && data.objetEmail ? data.objetEmail : ""}
                    </h5>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: data.templatehtml,
                      }}
                    />
                  </div>
                </div>
              </div>
            )}

            {/* end of Template */}
            {/* Pieces joints */}
            {images && images.length > 0 && (
              <div className="col">
                <div className="card mb-4">
                  <div className="card-header">
                    <strong>Pièces jointes </strong>
                    <span className="small ms-1">
                      | Les pièces jointes incluses dans cet e-mail
                    </span>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      {images.map((image, index) => (
                        <div className="col-md-6" key={index}>
                          <img
                            src={image}
                            alt="example"
                            style={{ width: "100%", height: "95%" }}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* end of Pieces joints */}
            {/* Statistiques Pourcentage Clients */}

            {dataContact && (
              <div className="col">
                <div className="card mb-4">
                  <div className="card-header">
                    <strong>Statistiques Pourcentage Clients </strong>
                    <span className="small ms-1">
                      | Pourcentage Clients pour chaque genre
                    </span>
                  </div>
                  <div className="card-body">
                    <ChartContact data={dataContact} />
                  </div>
                </div>
              </div>
            )}
            {/* end of Statistiques Pourcentage Clients*/}
            {/* Statistiques Pays des clients */}
            {dataContact && (
              <div className="col">
                <div className="card mb-4">
                  <div className="card-header">
                    <strong>Statistiques Pourcentage Clients </strong>
                    <span className="small ms-1">| Pays des clients</span>
                  </div>
                  <div className="card-body">
                    <ChartContact data={dataContact} />
                  </div>
                </div>
              </div>
            )}
            {/* end of Statistiques Pays des clients*/}

            {/* Statistiques Age des clients */}
            {dataContact && (
              <div className="col">
                <div className="card mb-4">
                  <div className="card-header">
                    <strong>Statistiques Pourcentage Age Clients </strong>
                    <span className="small ms-1">| Age des clients</span>
                  </div>
                  <div className="card-body">
                    <ChartContact data={dataContact} />
                  </div>
                </div>
              </div>
            )}
            {/* end of Statistiques Age des clients*/}
          </div>
        </section>
      </div>
    </>
  );
}

export default StatCampagneE;
